import React from "react";
import "./TestimonialCard.scss"

function TestimonialCard({ image, label,index }) {
    return (
        <>
            <div className="highlights-container">
                <div key={index} className="highlight-item">
                    <div className="highlight-circle">
                        <img src={image} alt={label} />
                    </div>
                    <p className="highlight-label">{label}</p>
                </div>
            </div>
        </>
    );
}
export default TestimonialCard;